import { render, staticRenderFns } from "./MalayDragon.vue?vue&type=template&id=01543820&"
import script from "./MalayDragon.vue?vue&type=script&lang=js&"
export * from "./MalayDragon.vue?vue&type=script&lang=js&"
import style0 from "./MalayDragon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports